var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { staticClass: "nav nav-tabs oc-settings__tabs" },
      _vm._l(_vm.tabs, function(tab, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "oc-tabs__tab",
            class: { active: index == _vm.tabAcive }
          },
          [
            _c(
              "a",
              {
                staticClass: "oc-tabs__link",
                attrs: { href: _vm.url },
                on: {
                  click: function($event) {
                    return _vm.$emit("select", index)
                  }
                }
              },
              [_vm._v(_vm._s(tab))]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-content" },
      [_c("br"), _vm._v(" "), _vm._t("contents")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47c69f16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c69f16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/Tabs.vue
// module id = 93
// module chunks = 0